var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ThumbsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38,24.9l-1.7-12.2C35.9,9.4,33.1,7,29.8,7h-9.3C14.7,7,10,11.7,10,17.5v6.6c0,2.5,1.2,5,3.3,7c2.6,2.5,8.9,11.6,8.9,11.7 c0.1,0.1,0.2,0.2,0.4,0.2c0,0,0.1,0,0.1,0c1.1-0.2,3.3-1.3,3.3-4.2c0-0.6-0.1-1.4-0.4-2.5c-0.4-2-0.9-3.6-1.7-5.4 c-0.1-0.2-0.1-0.4,0-0.6c0.1-0.1,0.2-0.2,0.4-0.2h9.2c1.3,0,2.5-0.6,3.4-1.5C37.8,27.5,38.2,26.2,38,24.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ThumbsDown);
export default __webpack_public_path__ + "static/media/icons8-thumbs-down.a91122d1f943a82572594450c38d5e0e.svg";
export { ForwardRef as ReactComponent };